export default "__VITE_ASSET__Dyb37FeO__"